import { render, staticRenderFns } from "./NotifyUsersSwitch.vue?vue&type=template&id=5b785cf6"
import script from "./NotifyUsersSwitch.vue?vue&type=script&lang=js"
export * from "./NotifyUsersSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports